import React, { useMemo } from 'react';
import clsx from 'clsx';
import { CarIcon, MultipleCarsIcon } from '../../icons';
import { cfmsCodesOrderTracking, orderSteps } from '../../config/constants';

const OrderCarCard = ({
  className,
  cardRef,
  carData,
  selectedCar,
  isAssignedView = false,
  isDashbord = false,
  handleCardClick,
}) => {
  const { plateno, title, subTitle, info, step, orderLine, cncode, quantity } = carData;
  
  const isSelected = useMemo(() => {
    return plateno && selectedCar?.plateno === plateno;
  }, [selectedCar?.plateno, plateno]);

  return (
    <li
      ref={cardRef}
      className={clsx(
        `p-3 flex w-full items-center justify-between rounded-lg h-full ${
          isSelected ? 'bg-[#282828] text-white' : 'bg-white'
        }`,
        className
      )}
      onClick={handleCardClick && handleCardClick}
      key={plateno}
    >
      
      <div className="w-full flex flex-row gap-2 justify-between items-start">
        <div className="flex flex-row items-center justify-center gap-2 w-full">
          <div className="flex flex-row items-center justify-center gap-2 w-full">
            {isAssignedView ? (
              <div className="rounded-full bg-powdergrey p-3">
                {quantity > 1 ? 
                  <MultipleCarsIcon className={'min-w-[20px]'} color={isSelected ? 'white' : 'black'} />
                  : <CarIcon className={'min-w-[20px]'} color={isSelected ? 'white' : 'black'} />}
              </div>
              ) : quantity > 1 ? 
                <MultipleCarsIcon className={'min-w-[24px]'} color={isSelected ? 'white' : 'black'} />
                : <CarIcon className={'min-w-[24px]'} color={isSelected ? 'white' : 'black'} />
            }
            <div className="w-full flex flex-col gap-1 ">
              <p className={clsx("text-body ", !isDashbord && 'w-[140px] truncate')}>
                {title} {isDashbord && quantity > 1 ? `- Ποσότητα ${quantity}` : ""}
              </p>
              {step < 7 ? <p
                className={`text-disclaimer w-full ${
                  isDashbord ? [7, 8, 9].includes(step) ? 'text-primary':'text-fadedgrey' : 'w-[100px] '
                  } text-[12px] ${isSelected ? 'white' : 'text-fadedgrey'}`}
                  title={info}
                >
                  {info}
                </p> 
                : <p className={`text-[12px] ${isSelected ? 'white' : 'text-fadedgrey'}`}>
                    {isDashbord ? `Κωδικός προσφοράς ${cncode}` : orderSteps.find(item => item.step === cfmsCodesOrderTracking[orderLine?.code])?.title}
                  </p>
              }
            </div>
          </div>
          {quantity > 1 ? 
          <div className='flex flex-col items-end'>
            <p className={`text-xs whitespace-nowrap ${isSelected? "text-white" : "text-fadedgrey"} `}>
              Ποσότητα παραγγελίας
            </p>
            <p className={`text-xs whitespace-nowrap ${isSelected? "text-white" : "text-fadedgrey"} `}>
              {quantity} αυτοκίνητα
            </p>
          </div> : 
            !isDashbord && cfmsCodesOrderTracking[orderLine?.code] < 7 ?
              orderLine?.DeliverDate !== "1900-01-01" && orderLine?.DeliverDate !== null && orderLine?.DeliverDate !== undefined && 
              <div className='w-full h-full flex flex-col items-end justify-end'>
                <p className={`text-[12px]  text-right ${isSelected ? 'white' : 'text-fadedgrey'}`}>Εκτιμώμενη παράδοση</p>
                  <p className={`text-[12px]  ${isSelected ? 'white' : 'text-fadedgrey'}`}>         
                    {(() => {
                      const [y, m, d] = orderLine?.DeliverDate.split("-");
                      return `${d}.${m}.${y}`;
                    })()}
                  </p>
            </div> : !isDashbord && ['1001','1002','1003','1004','1009','1010','1011','1012','1013','1005','1006',].includes(orderLine?.code) && orderLine?.AvailDate !== "1900-01-01" && orderLine?.AvailDate !== null && orderLine?.AvailDate !== undefined && 
              <div className='w-full h-full flex flex-col items-end justify-end'>
                <p className={`text-[12px]  text-right ${isSelected ? 'white' : 'text-fadedgrey'}`}>Παραλαβή από</p>
                  <p className={`text-[12px]  ${isSelected ? 'white' : 'text-fadedgrey'}`}>         
                    {(() => {
                      const [y, m, d] = orderLine?.AvailDate.split("-");
                      return `${d}.${m}.${y}`;
                    })()}
                  </p>
            </div> 
          }
        </div>
      </div>
      {/* current step title right side */}
      {/* {step < 7 && <p
        className={`font-[700] text-[12px] ${
          [7, 8, 9].includes(step)
            ? 'text-primary'
            : isSelected
            ? 'white'
            : 'text-fadedgrey'
        }`}
        title={info}
      >
        {info}
      </p>} */}
    </li>
  );
};

export default OrderCarCard;
